
function createEmailRegex() {
    return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
}

function createUrlRegex() {
    return /^(?:https?:\/\/)?(?:[a-z0-9\-]+(\.[a-z0-9\-]+)*)\.(?:[a-z]+)(?::\d{1,5})?(?:$|[\?\/#])[^\n\t]*$/i;
}

function createIntRegex() {
    return /^-?[0-9]+$/;
}

function createDomainRegex() {
    return /^(((([a-zA-Z0-9])|([a-zA-Z0-9][a-zA-Z0-9\-]{0,86}[a-zA-Z0-9]))\.(([a-zA-Z0-9])|([a-zA-Z0-9][a-zA-Z0-9\-]{0,73}[a-zA-Z0-9]))\.(([a-zA-Z0-9]{2,12}\.[a-zA-Z0-9]{2,12})|([a-zA-Z0-9]{2,25})))|((([a-zA-Z0-9])|([a-zA-Z0-9][a-zA-Z0-9\-]{0,162}[a-zA-Z0-9]))\.(([a-zA-Z0-9]{2,12}\.[a-zA-Z0-9]{2,12})|([a-zA-Z0-9]{2,25}))))$/;
}

function createVietnamesePhoneRegex() {
    return /^0(?:[35789]|1[2689])\d{8}$/;
}

export {
    createEmailRegex,
    createUrlRegex,
    createIntRegex,
    createDomainRegex,
    createVietnamesePhoneRegex,
}
